import Utils from './utils/utils'


/**
 * APP扫码登录
 */
export class QRCodeLogin {

    constructor () {
        this.qrData = null;
        this.$obj = null;
        this.timer = null;
        this.websocket = null;

        QRCodeLogin.STATUS_MAP = {
            DEFAULT: 0,
            LOADED_SUCC: 1, // 加载成功
            LOADED_ERR: -1, // 加载失败
            UPLOADED_SUCC: 2,   // 加载后上报成功
            UPLOADED_ERR: -2,   // 加载后上报失败
            EXPIRED: -3,        // 二维码过期
            SCAN_SUCC: 4,       // 扫码成功
        };

        QRCodeLogin.SOCKET_URL = 'wss://www.gwdang.com/sck';
        // this.status = QRCodeLogin.STATUS_MAP.DEFAULT;
    }

    clear () {
        clearInterval(this.timer);
        this.timer = null;
        // this.qrData = null;
    }

    create ($obj, refresh = false) {
        this.$obj = $obj;

        if (refresh) {
            this.refresh();
        }

        if (! this.websocket) {
            this.createSocket().then(evt => {

                if (! this.qrData) {
                    this.getQrcode($obj);

                }  else {
                    this.socketSend(JSON.stringify({
                        action: 'QrCodeLogin',
                        msg: { tid : this.qrData.id }
                    }));
                }
            }).catch(err => {
                console.error(err)
            })
        } else {
            this.getQrcode($obj);
        }
    }

    /**
     * 获取二维码数据
     * @param $obj
     */
    getQrcode ($obj) {
        // this.status = QRCodeLogin.STATUS_MAP.DEFAULT;

        Utils.HttpRequest.get("https://u.gwdang.com/helper/QrCode?event=scanLogin", {}, {}, (response) => {
            if (response.code != 1) {
                $obj.html(`<div class='wrapper pos_r'><div class='qrcode-mask pos_a'><p style='margin-top: 58px;'>网络异常</p><p>请<span class='txt-red refresh-qrcode'>刷新</span></p></div></div>`);
                let _this = this;
                $obj.find('.wrapper .refresh-qrcode').on('click', function () {
                    _this.refresh();
                    _this.create(_this.$obj, true);
                });

                _this.qrData = null;
                // this.status = QRCodeLogin.STATUS_MAP.LOADED_ERR;
                return ;
            }

            this.qrData = response.data;
            // this.status = QRCodeLogin.STATUS_MAP.LOADED_SUCC;

            this.clear();

            // 上报
            this.socketSend(JSON.stringify({
                action: 'QrCodeLogin',
                msg: { tid : this.qrData.id }
            }));
        });
    }

    /**
     * 上报成功后，前端渲染二维码
     */
    uploadSuccess () {
        if (! this.qrData) return;

        if (this.status === QRCodeLogin.STATUS_MAP.EXPIRED) return;
        if (this.timer) return;

        this.$obj.html(`<div class='wrapper pos_r'><img src='${this.qrData.qrImgStr}' class='qrcode'></div><p class='info mt-15'>打开 <span class='txt-red'>购物党APP</span> 扫码登录</p>`);

        if (this.qrData.expired) {
            let timeAway = 0;
            this.timer = setInterval(() => {
                timeAway += 10;
                if (timeAway >= this.qrData.expired) {
                    this.expired();
                }
            }, 1000 * 10)
        }
    }

    /**
     * app端扫码登录成功
     * @param loginData
     */
    loginSuccess (loginData) {
        let end = new Date(loginData.expire * 1e3);
        let userTime = new Date(loginData.time);
        Utils.Cookies.setItem('GWD_USER_TOKEN', loginData.token, end, '/', '.gwdang.com');
        Utils.Cookies.setItem('GWD_USER_TIME', parseInt(userTime.getTime() / 1e3), end, '/', '.gwdang.com');
        Utils.Cookies.setItem('plt_user_email', '_default', end, '/', '.gwdang.com');

        window.location.reload();
    }

    /**
     * 扫码成功，等待确认
     */
    scanSuccess () {
        if (QRCodeLogin.STATUS_MAP.SCAN_SUCC === this.status || QRCodeLogin.STATUS_MAP.EXPIRED === this.status) {
            return ;
        }

        // this.clear();
        this.status = QRCodeLogin.STATUS_MAP.SCAN_SUCC;

        this.$obj.find('.wrapper .qrcode-mask').remove();
        this.$obj.find('.hint').remove();
        this.$obj.find('.wrapper').append("<div class='qrcode-mask pos_a'><img src='/template/metro/images/login/icon_success_big@2x.png' style='width: 50px;height: 50px; margin-top: 54px;'></div>");
        this.$obj.find('.info').before("<p class='hint hui999 mt-10'>扫码成功</p>");
        this.$obj.find('.info').text("请在手机上根据提示确认登录").addClass('bold').css('margin-top', '10px');

        this.$obj.parents('.section-wrapper').siblings('.other_platform').css('margin-top', '22px');
    }

    expired () {
        if (this.status === QRCodeLogin.STATUS_MAP.EXPIRED) {
            return;
        }

        this.clear();
        this.status = QRCodeLogin.STATUS_MAP.EXPIRED;

        this.$obj.find('.wrapper .qrcode-mask').remove();
        this.$obj.find('.hint').remove();
        this.$obj.find('.wrapper').append("<div class='qrcode-mask pos_a'><p style='margin-top: 58px;'>二维码失效</p><p>请<span class='txt-red refresh-qrcode'>刷新</span>二维码</p></div>");
        this.$obj.find('.info').text("请在手机上根据提示重新扫码").addClass('bold').css('margin-top', '15px');

        let _this = this;
        this.$obj.find('.wrapper .refresh-qrcode').on('click', function () {
            _this.refresh();
            _this.create(_this.$obj, true);
        });
    }

    /**
     * 刷新二维码
     */
    refresh () {
        this.qrData = null;

        this.status = QRCodeLogin.STATUS_MAP.DEFAULT;
        this.clear();
    }

    /**
     * 创建websocket，事件监听
     */
    createSocket () {
        try {
            let _this = this;
            return new Promise((resolve, reject) => {
                _this.websocket = new WebSocket(QRCodeLogin.SOCKET_URL);

                _this.websocket.onopen = function(evt) {
                    resolve(evt);
                };

                this.websocket.onmessage = function(evt) {
                    _this.onMessage(evt)
                };

                _this.websocket.onclose = function(evt) {
                    _this.onClose(evt)
                };

                _this.websocket.onerror = function(err) {
                    reject(err);
                };
            });

        } catch (error) {
            console.error(error);
        }
    }

    /**
     * websocket 发送消息
     * @param data String
     */
    socketSend (data) {
        try {
            this.websocket.send(data)
        } catch (error) {
            console.error(error);
        }
    }

    onMessage (e) {
        if ('string' === typeof e.data) {
            let jsonData = JSON.parse(e.data);

            if (jsonData.code == 1) {

                if (jsonData.data) {
                    this.loginSuccess(jsonData.data);

                } else if (jsonData.msg === 'Success') {
                    this.uploadSuccess();

                } else if (jsonData.msg === 'LoginConnected') {
                    this.scanSuccess();

                } else if (jsonData.msg === 'Connected') {   // 首次加载
                } else {
                    console.error(jsonData);
                }
            } else {
                this.expired();
            }
        }
    }

    onClose (e) {
        this.websocket = null;

        this.create(this.$obj);
    }
}